<template>
  <b-modal
    id="confirm-move-member-tier-modal"
    hide-header
    hide-footer
    hide-backdrop
    modal-class="bg-transparent"
    content-class="member-tier-content"
    body-class="member-tier-body"
    dialog-class="member-tier-dialog"
  >
    <template v-if="isLoading">
      Loading...
      <div class="loading-spinner"></div>
    </template>
    <template v-else>
      <img src="@/assets/images/warning-yellow-circle.png" alt="Warning" />
      <span class="ml-2">Are youre sure you want to move this member?</span>
      <div class="mt-2 text-right">
        <span id="action-yes" class="action" @click="moveMemberTier">Yes</span>
        <span
          id="action-no"
          class="action"
          @click="
            $root.$emit('bv::hide::modal', 'confirm-move-member-tier-modal')
          "
          >No</span
        >
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "ConfirmMoveMemberTierModal",
  props: ["selectedTier", "selectedSubTier", "selectedMemberId"],
  methods: {
    async moveMemberTier() {
      const payload = {
        customer_id: this.selectedMemberId,
        tier_id: this.selectedTier.id,
      };

      if (this.selectedSubTier) payload.subtier_id = this.selectedSubTier.id;

      await this.$store.dispatch(
        "programMembershipTiers/moveMemberTier",
        payload
      );
      this.$root.$emit("bv::hide::modal", "confirm-move-member-tier-modal");
      this.$parent.setParam();
    },
  },
  computed: {
    ...mapState("programMembershipTiers", ["isLoading"]),
  },
};
</script>

<style>
.member-tier-content {
  border: 1.5px solid #ffd231;
  width: 382px;
}
.member-tier-body {
  font-size: 14px;
  padding: 15px;
  text-align: center;
}
.member-tier-dialog {
  position: fixed;
  left: 18%;
  bottom: 5%;
}
.action {
  font-size: 16px;
  font-family: MainFontBold, sans-serif;
  font-weight: normal;
  padding: 5px;
  cursor: pointer;
}
#action-yes {
  color: #ff8b20;
  margin: 20px 5px;
}
#action-no {
  color: #bebebe;
  margin: 20px;
}
</style>